//axios api
import api from "@/lib/Api";

export const getAllNotice = async () => {
  try {
    const queryRoute = "/notice/getAllNotice";

    const reqBody = {
      type: "website",
      getByRegion: 0,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createOrUpdateNotice = async (data, id) => {
  console.log("id", id);
  try {
    const queryRoute = `/notice/createOrUpdateNotice/${id}`;

    const reqBody = {
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getNoticeByNoticeId = async (id) => {
  try {
    const queryRoute = `/notice/getNoticeByNoticeId/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const noticeDeleteByid = async (checkedValue) => {
  try {
    const queryRoute = `/notice/noticeDeleteByid`;

    const reqBody = {
      checkedValue: checkedValue,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getPushNotificationByUser = async () => {
  try {
    const queryRoute = `/notice/pushNotification`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getFullStaffLists = async () => {
  try {
    const queryRoute = `/notice/fullStaffLists`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createPushNotification = async (body) => {
  try {
    const queryRoute = `/notice/pushNotification`;
    const reqBody = { ...body };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updatePushNotification = async (body, id) => {
  try {
    const queryRoute = `/notice/pushNotification/${id}`;
    const reqBody = { ...body };
    const fetchRes = api.axios.put(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getPushNotificationById = async (id) => {
  try {
    const queryRoute = `/notice/pushNotification/${id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
